export default {
	data() {
		return {
            height: 450,
            height1:450,
            screenWidth:''
		}
	},
    mounted() {
        window.onresize = () => { //屏幕尺寸变化就重新赋值
            return (() => {
                this.screenWidth = document.documentElement.clientWidth
            })()
        }
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                var widtt = val < 1200 ? 1200 : val
                this.height = this.height1 / 1920 * widtt
            },
            immediate: true
        },
    },
    created: function () { 
        this.screenWidth = document.documentElement.clientWidth
      }
}



// WEBPACK FOOTER //
// ./src/util/window.js